import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IStripeApi {
	abstract sessionStatus(idSession: string): Promise<AxiosResponse<Result<string>>>;
}
